import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import BillingOrderNewEditStepsForm from '@/sections/administrative/accounts/organizations/forms/billing-order-new-edit-steps-form';

export default function BillingOrderCreatePage() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('New Billing Order')} | Orion</title>
      </Helmet>

      <BillingOrderNewEditStepsForm />
    </>
  );
}
